<template>
  <div class="row documento_dados">
    <div class="small-4 medium-8 large-6 columns show-for-large">
      <div class="row">
        <div class="small-12 medium-4 large-3 columns ano_doc_legislacao">
          <h3 class="ano">{{ item.doc_ano }}</h3>
        </div>
        <div class="small-8 medium-8 large-9 columns hide-for-small-only">
          <h3>{{ item.doc_titulo }}</h3>
        </div>
      </div>
    </div>
    <div class="small-12 medium-12 large-6 columns">
      <div class="row">
        <div class="small-12 medium-10 large-12 columns othercolumn">
          <div class="row" v-for="ficheiro in item.doc_ficheiros">
            <div class="small-1 medium-1 large-1 columns img_icon_doc">
              <a :href="ficheiro.doc_ficheiros_url">
                <img class="pdf_icon"
                  :src="getDocumentIcon(ficheiro.extensao)">
              </a>
            </div>
            <div class="small-11 medium-10 large-11 columns descarregar_doc">
              <a :target="ficheiro.extensao == 'word' || ficheiro.extensao == 'excel' ? '_self' : '_blank'"
                :href="ficheiro.doc_ficheiros_url">
                {{ ficheiro.doc_ficheiros_nome }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pdf from "@/assets/icons/icon_pdf_cinza.png";
import word from "@/assets/icons/icons-05.png";
import officeForm from "@/assets/icons/icons-06.png";
import excel from "@/assets/icons/icons-07.png";


export default {
  props: ["item"],
  setup() {

    const documentIcons = {
      pdf,
      excel,
      word,
      officeForm,
    };

    const getDocumentIcon = (doctype) => {
      return documentIcons[doctype] || pdf;
    };

    return {
      getDocumentIcon
    }
  }
}
</script>

<style lang="scss" scoped>
.row .row,
.documento_dados {
  margin-right: 0px;
  margin-left: 0px;
}

.documento_dados {
  border-bottom: 1px solid #a7a5a5;
}

.documento_dados .columns {
  padding-left: 0;
  padding-right: 0;
}

.documento_dados .columns .columns {
  padding-right: 7px;
  padding-top: 7px;
  padding-bottom: 7px;
  padding-left: 0;
}

h3 {
  font-family: "Montserrat";
  font-size: 15px;
  padding-top: 14px;
  color: #707475;
  padding-right: 20px;
}

h3.ano {
  font-family: "Montserrat";
  color: #707475;
  font-size: 15px;
  padding-top: 14px;
  padding-right: 20px;
  padding-left: 0;
}

.documento_dados .columns .columns.othercolumn {
  padding-right: 0;
}

.img_icon_doc a img {
  width: 28px;
}

.descarregar_doc a {
  padding-left: 5px;
  display: block;
  padding-top: 7px;
  font-family: "Montserrat Bold";
  color: #707475;
  font-size: 15px;
}

.descarregar_doc a:visited {
  color: #707475 !important;
}

@media screen and (max-width:767px) {
  .img_icon_doc a img {
    width: 25px;
  }
  .descarregar_doc a {
    padding-top: 5px;
    font-family: "Montserrat Bold";
    color: #707475;
    font-size: 14px;
    margin-left: 0;
    margin-bottom: -5px;
  }

  .documento_dados .columns .columns{
    padding-bottom: 0;
  }

  .documento_dados {
    border-bottom: transparent;
  }
  
}
</style>